import BaseModel from '@/api/RestModels/baseModel';
import api from '@/api/RestModels/client';

class UserRestModel extends BaseModel {
  path = 'user'

  getToken = async (payload) => api.post(`${this.path}/candidate`, { json: payload }).json();
}

export default new UserRestModel()
